<template>
  <div class="auth-register-step mx-1-4rem mb-3">
    <ul class="wizard wizard-steps-5 w-100 max-w-450-mobile" :class="'wizard-steps-' + maxSteps">
      <li v-for="n in maxSteps" :key="n">
        <div class="step" :class="{ done: step > n, current: step === n }">
          <svg v-if="step > n" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.05334 10.3867C6.92 10.3867 6.79334 10.3333 6.7 10.24L4.81333 8.35333C4.62 8.16 4.62 7.84 4.81333 7.64667C5.00667 7.45333 5.32667 7.45333 5.52 7.64667L7.05334 9.18L10.48 5.75333C10.6733 5.56 10.9933 5.56 11.1867 5.75333C11.38 5.94667 11.38 6.26667 11.1867 6.46L7.40667 10.24C7.31334 10.3333 7.18667 10.3867 7.05334 10.3867Z"
              fill="white"
            />
          </svg>
          <div v-if="step === n" class="dot"></div>
          <div v-if="n !== maxSteps" class="line" :class="{ active: step >= n }"></div>
        </div>
        <div class="number">{{ n }}</div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
    maxSteps: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({}),
  computed: {},
  watch: {},
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/common/base/base-mixin';

$color-default: #bdc3c7;
$color-active: #c84177;
$step-size: 20px;
$steps: 20;

.wizard {
  $wizard: &;
  padding: 0;
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  list-style: none;
  width: 90%;
  display: table;
  position: relative;
  max-width: 260px;

  svg {
    position: absolute;
    width: 20px;
    height: 20px;
    left: 0;
    top: 0;
  }

  .dot {
    width: 5px;
    height: 5px;
    margin-left: 8px;
    margin-top: 8px;
    background: #c63e7c;
    border-radius: 9999px;
  }

  .number {
    color: #5b5b5b;
    font-size: 13px;
    font-weight: 400;
  }

  .line {
    position: absolute;
    border-bottom: 2px solid $color-default;
    width: 28px;
    top: 50%;
    left: 22px;

    @include tablet-down {
      width: 330%;
    }

    &.active {
      border-color: $color-active;
    }
  }

  > * {
    display: table-cell;
    text-align: center;

    .step {
      width: $step-size;
      height: $step-size;
      border-radius: $step-size;
      border: 2px solid $color-default;
      color: $color-default;
      font-weight: 300;
      background: #fff;
      text-align: center;
      display: inline-block;
      box-sizing: content-box;
      position: relative;

      &.current {
        border-color: $color-active;
        color: $color-active;
        font-weight: 500;
        border-width: 2px;
        margin-top: -1px;
      }

      &.done {
        border-color: $color-active;
        color: $color-active;
        background-color: $color-active;
        font-weight: 500;
        border-width: 2px;
        margin-top: -1px;
      }

      &:after {
        display: block;
        width: $step-size;
        height: $step-size;
        background-color: #fff;
        position: absolute;
        border: 10px solid #fff;
        box-sizing: content-box;
      }

      > * {
        line-height: $step-size;
      }
    }
  }

  @for $i from 1 through $steps {
    &-steps-#{$i} {
      > * {
        width: 100% / $i;
      }

      &:after {
        left: (100% / $i/2);
        right: (100% / $i/2);
      }
    }
  }
}
</style>
